import { useState, useEffect } from 'react';
import api, { authService } from '../services/api';

// Único lugar donde se define qué queda accesible en cada nivel de bloqueo.
const MODULOS_REDUCIDO = ['farmacia'];
const OPCIONES_FARMACIA_REDUCIDO = ['productos', 'conteo'];

const MODULOS_BLOQUEO_TOTAL = ['economia'];
const OPCIONES_ECONOMIA_BLOQUEO_TOTAL = ['monitor-envios'];

export function useModoReducido() {
  const [estado, setEstado] = useState('normal');
  const [cargando, setCargando] = useState(true);

  const user = authService.getCurrentUser();
  const esAdministrador = user?.rol === 'ADMINISTRADOR';

  useEffect(() => {
    if (esAdministrador) { setCargando(false); return; } // admin nunca se ve afectado
    const ueId = user?.ueIdEstablecimiento || user?.UeIdEstablecimiento;
    if (!ueId) { setCargando(false); return; }
    api.get('/sistema/uso/validar', { params: { ueId } })
      .then(r => setEstado(esAdministrador ? 'normal' : (r.data?.estado || 'normal')))
      .catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  const reducido = !esAdministrador && (estado === 'reducido' || estado === 'bloqueoInminente');
  const bloqueoTotal = !esAdministrador && estado === 'bloqueoTotal';

  const moduloPermitido = (moduloId) => {
    if (bloqueoTotal) return MODULOS_BLOQUEO_TOTAL.includes(moduloId);
    if (reducido) return MODULOS_REDUCIDO.includes(moduloId);
    return true;
  };

  const opcionFarmaciaPermitida = (opcionId) => {
    if (bloqueoTotal) return false; // Farmacia queda 100% bloqueada en este nivel
    if (reducido) return OPCIONES_FARMACIA_REDUCIDO.includes(opcionId);
    return true;
  };

  const opcionEconomiaPermitida = (opcionId) => {
    if (bloqueoTotal) return OPCIONES_ECONOMIA_BLOQUEO_TOTAL.includes(opcionId);
    return true; // en reducido, Economía completa ya está bloqueada por moduloPermitido
  };

  return { estado, reducido, bloqueoTotal, cargando, moduloPermitido, opcionFarmaciaPermitida, opcionEconomiaPermitida };
}